import { EmissionsCategoryEnum, StatusEnum } from '@shared/api/types';
import { cn } from '@shared/lib/utils';
import { ClassValue } from 'clsx';
import ratingA_svg from './clouds/cloud-a.svg';
import ratingB_svg from './clouds/cloud-b.svg';
import ratingC_svg from './clouds/cloud-c.svg';
import ratingD_svg from './clouds/cloud-d.svg';
import ratingE_svg from './clouds/cloud-e.svg';
import inProgress from './clouds/cloud-only-progress.svg';

import ratingA_png from './clouds/cloud-a.png';
import ratingB_png from './clouds/cloud-b.png';
import ratingC_png from './clouds/cloud-c.png';
import ratingD_png from './clouds/cloud-d.png';
import ratingE_png from './clouds/cloud-e.png';

export interface RatingCloudProps {
  rating?: EmissionsCategoryEnum | null;
  status?: StatusEnum;
  className?: ClassValue;
  format?: 'svg' | 'png';
}

const RatingCloud = ({
  rating,
  status,
  className,
  format = 'svg',
}: RatingCloudProps) => {
  let imageSrc;

  switch (rating) {
    case null:
      imageSrc = inProgress;
      break;
    case 'A':
      imageSrc = format === 'svg' ? ratingA_svg : ratingA_png;
      break;
    case 'B':
      imageSrc = format === 'svg' ? ratingB_svg : ratingB_png;
      break;
    case 'C':
      imageSrc = format === 'svg' ? ratingC_svg : ratingC_png;
      break;
    case 'D':
      imageSrc = format === 'svg' ? ratingD_svg : ratingD_png;
      break;
    case 'E':
      imageSrc = format === 'svg' ? ratingE_svg : ratingE_png;
      break;
    default:
      imageSrc = inProgress; // default image or leave it blank
      break;
  }

  return (
    <img
      src={imageSrc}
      className={cn(
        'w-10',
        {
          'w-12': rating,
        },
        className
      )}
      alt={`Rating: ${rating}`}
    />
  );
};

export default RatingCloud;
